<script lang="ts">
  import type { CtaLink } from '$types';

  export let pre_title_image_url: string = '';
  export let title: string = '';
  export let description: string = '';
  export let notes: string = '';
  export let links: CtaLink[] = [];
  export let class_name: 'add-cards' | 'mobile-apps' | string = '';
  export let color: 'dark' | 'light' | 'gradient' | string = 'dark';
  export let image_url: string = '';
  export let second_image_url: string = '';
</script>

<section class="section-cta cta {class_name} color-{color}">
  <div class="wrap">
    <div class="content">
      {#if pre_title_image_url}
        <div class="qr-code">
          <img src={pre_title_image_url} alt="" />
        </div>
      {/if}
      <div>
        {#if title}
          <h2>{title}</h2>
        {/if}

        {#if description}
          <div class="description">
            {@html description}
          </div>
        {/if}
      </div>
      {#if links.length}
        <div class="links">
          {#each links as link}
            {#if !link.image_url}
              <a href={link.link} class={link?.highlight ? 'highlight' : 'base'}>
                {link.link_text}
              </a>
            {:else}
              <a href={link.link} class="link" title={link.link_text}>
                <img src={link.image_url} alt="" />
              </a>
            {/if}
          {/each}
        </div>
      {/if}

      {#if notes}
        <div class="notes">
          {notes}
        </div>
      {/if}
    </div>

    {#if image_url}
      <div class="image">
        <img src={image_url} alt="" />
      </div>
    {/if}
    {#if second_image_url}
      <div class="image">
        <img src={second_image_url} alt="" />
      </div>
    {/if}
  </div>
</section>
